<div
  [ngClass]="{
    'filter-card m-2': filterBox,
    card: !filterBox && !noteBox
  }"
  >
  @if (showHeader) {
    <div
    [ngClass]="{
      'filter-header py-1 px-2': filterBox,
      'card-header': !filterBox && !fieldTableBox,
      'pb-1': noteBox,
      filterOpen: showContent === true && filterBox
    }"
      >
      {{ title }}
    </div>
  }
  @if (showContent) {
    <div>
      <ng-content></ng-content>
    </div>
  }
</div>
